import { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { printDataUpdateRequest, setFlyerCurrentWeek } from '../../../actions'
import EditFlyerContent from '../present/EditFlyerContent'
import { FLYER_DATA, PRINT_TYPES_DATA, FLYER_DATA_CURRENT_WEEK, UI_GENERAL } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import { generatePath } from 'react-router-dom';
import hasUpdateProgram from '../../../hoc/hasUpdateProgram';

const mapDispatchToProps = (dispatch, ownProps) => ({
  printUpdateRequest: () => {
    dispatch(printDataUpdateRequest())
  },
  updateFlyerCurrentWeek: week => {
    dispatch(setFlyerCurrentWeek(parseInt(week)))
  }
})

const mapStateToProps = (state) => ({
    generatePDF: getData(state, [PRINT_TYPES_DATA, 'status']),
    generatePDFError: getData(state, [PRINT_TYPES_DATA, 'error']),
    hasChanges: getData(state, [FLYER_DATA, 'hasChanges']),
    flyerServerData: getData(state, FLYER_DATA),
    activeWeek: getData(state, FLYER_DATA_CURRENT_WEEK),
    uiRequestOverlayType: getData(state, [UI_GENERAL, 'requestOverlay', 'overlayType'])
})

class EditFlyerContentContainer extends Component {
  constructor(props) {
    super(props)
  }

  componentDidUpdate() {
    const { activeWeek, updateFlyerCurrentWeek } = this.props
    const { week } = this.props.match.params

    if( activeWeek != week && week !== "custom") {
      updateFlyerCurrentWeek(week) 
    }
  }

  render() {
    const {
      match,
      generatePDF,
      flyerServerData,
      generatePDFError,
      hasChanges,
      goBackPath,
      printUpdateRequest,
      uiRequestOverlayType,
      programStatus,
      programError
    } = this.props

    const { cinemaId, printType, side, printFormat, landscape, week, printPk } = match.params
    const closePagePath = generatePath(goBackPath, match.params)

    return (
      <EditFlyerContent
        closePagePath={closePagePath}
        basicUrl={match.url}
        flyerServerData={flyerServerData}
        programError={programError}
        printPk={printPk}
        programStatus={programStatus}
        generatePDF={generatePDF}
        generatePDFError={generatePDFError}
        activeWeek={week}
        hasChanges={hasChanges}
        cinemaId={cinemaId}
        printType={printType} 
        side={side}
        printFormat={printFormat}
        uiRequestOverlayType={uiRequestOverlayType}
        landscape={landscape}
        printUpdateRequest={printUpdateRequest}
      />
    )
  }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(EditFlyerContentContainer)

